import React from 'react';
import { Url } from '@wix/da-url';
import { EXTENSION_TYPE_NAME } from '../constants';
const Viewer = ({ node })=>{
    var _node_attrs;
    const { user } = (_node_attrs = node.attrs) !== null && _node_attrs !== void 0 ? _node_attrs : {};
    return /*#__PURE__*/ React.createElement("a", {
        href: Url.userLink(user.username),
        "data-da-type": EXTENSION_TYPE_NAME,
        "data-user": JSON.stringify(user)
    }, "@", user.username);
};
Viewer.displayName = 'MentionViewer';
export default Viewer;

//# sourceMappingURL=Viewer.js.map